import { Link } from "react-router-dom";
import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import TicketCard from "../components/TicketCard";
import { LeafIcon, DropletIcon, CarIcon } from "../components/icons";
import styles from "./Services.module.css";

const GARDEN = [
  {
    value: "mowing-tidy",
    title: "Mowing & tidy",
    description:
      "Mowing, edging, and a general tidy-up — charged hourly, since bigger sections simply take more time to do properly.",
    price: "$40",
    unit: "/ hr",
    tilt: "-3deg",
  },
];

const CAR = [
  {
    value: "exterior-wash",
    title: "Exterior wash",
    description: "Full exterior wash, tyres and windows included.",
    price: "$60",
    tilt: "-2deg",
  },
  {
    value: "interior-clean",
    title: "Interior clean",
    description: "Vacuum, wipe-down and interior glass clean.",
    price: "$75",
    tilt: "3deg",
  },
  {
    value: "full-inside-out",
    title: "Full inside & out",
    description: "Exterior wash and full interior clean together.",
    price: "$125",
    tilt: "-4deg",
  },
];

function Services() {
  return (
    <>
      <SEO
        title="Services | BOI Gardens & Car Cleaning"
        description="Gardening and car cleaning services in Kerikeri."
      />

      <Navbar />

      <main className={styles.page}>
        <div className={styles.head}>
          <span className="eyebrow">Simple, upfront pricing</span>
          <h1>Our services</h1>
          <p>
            No quotes, no guessing — here's exactly what things cost. Get in
            touch to book, or ask if your job doesn't quite fit one of these.
          </p>
        </div>

        <div className={styles.groupLabel}>
          <LeafIcon />
          <h2>Gardening</h2>
        </div>
        <div className={styles.grid}>
          {GARDEN.map((item) => (
            <div key={item.title} className={styles.cardCol}>
              <TicketCard
                icon={<LeafIcon />}
                label="Garden care"
                float="slow"
                {...item}
              />
              <Link to={`/booking?service=${item.value}`} className={styles.bookLink}>
                Book this →
              </Link>
            </div>
          ))}
        </div>

        <div className={styles.groupLabel}>
          <CarIcon />
          <h2>Car cleaning</h2>
        </div>
        <div className={styles.grid}>
          {CAR.map((item) => (
            <div key={item.title} className={styles.cardCol}>
              <TicketCard
                icon={<DropletIcon />}
                label="Car cleaning"
                float="med"
                {...item}
              />
              <Link to={`/booking?service=${item.value}`} className={styles.bookLink}>
                Book this →
              </Link>
            </div>
          ))}
        </div>

        <p className={styles.note}>
          Gardening is charged hourly at $40/hr — bigger sections just take
          more hours, so the total depends on size. Car cleaning prices
          above are fixed per vehicle, always confirmed before we start.
        </p>
      </main>

      <Footer />
    </>
  );
}

export default Services;
